import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { fetchDiscounts } from "../../actions/discounts.actions";

import { debounce, get } from "lodash";
import ResourceList from "../Common/ResourceList";
import Loader from "../Common/Loader";

import Layout from "../Common/Layout";
import DiscountList from "./DiscountList";

export class DiscountListPage extends PureComponent {
  fetchList = () => {
    this.props.dispatch(fetchDiscounts());
  };

  fetchListDebounced = debounce(this.fetchList, 500);

  render() {
    return (
      <Layout.Page>
        <Layout.Header title="Discounts" />
        <Layout.Content>
          <ResourceList
            resourceType={"discounts"}
            fetch={this.fetchListDebounced}
            loader={<Loader key="__Discounts_Loader" message="Loading discounts..." />}
          >
            {list => <DiscountList discounts={list || []} defaultCurrency={this.props.currentTenantCurrency} />}
          </ResourceList>
        </Layout.Content>
      </Layout.Page>
    );
  }
}

const mapStateToProps = state => ({
  currentTenantCurrency: get(state, "common.currentTenant.defaultCurrency"),
  tenantSlug: get(state, "common.currentTenant.slug")
});

export default connect(mapStateToProps)(DiscountListPage);
